module.exports = __webpack_public_path__ + "img/banner-desc.22c0fd20.png";